<template>
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p>{{ facilityName}}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div v-if="facilityType !== 'tanker'" class="field">
            <!-- <p>Toggle Graph</p>
            <b-switch ></b-switch> -->
          </div>
          <span class="hr"> <hr /> </span>
          <div class="date">
            <div>
              <p>Showing For</p>
            </div>
            <div class="date-div">
              <b-datepicker icon="calendar-today" v-model="day" trap-focus>
              </b-datepicker>
               <b-button type="is-info" @click="$emit('day-change', day)">Go</b-button>
              <!-- <div class="buttons is-right">
                <b-button type="is-info" @click="$emit('day-change', day)">Go</b-button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'TitleBar',
  data() {
    return {
      day: this.selectedDate
    };
  },
  props: ['facilityName', 'facilityType', 'selectedDate']
};
</script>

<style>
.section {
  padding-top: 3.25rem !important;
  position: relative;
}
.primary {
  background: #3887f6;
  color: #ffffff;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  color: #ffffff;
}
.level-item p {
  margin-right: 10px;
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 14px;
  color: #000000;
  display: flex;
  align-items: center;
}
.field {
  display: flex;
  align-items: center;
}
.field:not(:last-child) {
  margin-bottom: 0;
}
.hr hr {
  border: 0.7px solid #c5c5c6;
  /* transform: rotate(90deg); */
  width: 2px;
  margin: 0;
}
.date {
  display: flex;
  align-items: center;
  padding: 0;
  justify-content: space-between;
}
.date-div {
  display: flex;
  justify-content: end;
}
.switch.is- :hover input[type="checkbox"]:checked + .check {
  background: transparent;
  border-color: #3887f6;
}
.switch.is-  input[type="checkbox"]:checked + .check {
  border-color: #3887f6;
}
.switch.is-  input[type="checkbox"]:checked + .check:before {
  background: #3887f6;
  margin-right: 17px;
}
.buttons.is-right {
  display: inline-flex;
}
.buttons {
  display: inline-flex !important;
}
.buttons.is-right:not(.has-addons) .button:not(.is-fullwidth) {
  margin-right: 50px;
}
@media screen and (max-width: 768px) {
  .level-item {
    display: block;
  }
  /* .level-left {
    text-align: center;
  } */

}
@media screen and (max-width: 360px) {
  .date {
    display: block;
  }
  .date-div {
    margin: 2px;
    padding:2px;
  }
}
</style>
